// MODULES
import { NFTI } from '@tacans/shared-marketplace-layer';
import React, { useCallback, useMemo } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { StyledLazyLoadImage } from 'src/features/common/collectible/components/nft-card-media/nft-card-media.styles';
import { NftPreviewModal } from 'src/features/common/collectible/modals/nft-preview-modal';
import { useIsWebpSupported } from 'src/hooks/use-is-webp-supported';
import { preventDefault } from 'src/utils/form.utils';
// RESOURCES
import { getNftContentType, NftContentType } from 'src/utils/nft.utils';
import { StyledWrapper, VideoInnerWrapper, VideoWrapper } from './styles';

export const NftPreviewMedia: React.VFC<{ nft: NFTI }> = ({ nft }) => {
    const isWebpSupported = useIsWebpSupported();

    const webpUrl = isMobileOnly ? nft.previewAssets?.webps?.mediumUrl : nft.previewAssets?.webps?.largeUrl;
    let videoUrl = isMobileOnly ? nft?.previewAssets?.videos?.mediumUrl : nft?.previewAssets?.videos?.largeUrl;
    if (!videoUrl) {
        videoUrl = nft?.previewAssets?.videos?.smallUrl;
    }
    const imageSrc = isWebpSupported && webpUrl ? webpUrl : nft.previewAssets?.originalUrl;

    const nftContentType = useMemo(() => getNftContentType(nft.contentType || ''), [nft.contentType]);

    const isVideo = nftContentType === NftContentType.VIDEO;
    const isImage = nftContentType === NftContentType.IMAGE;

    const onClickMedia = useCallback(() => {
        if (nftContentType === NftContentType.AUDIO || isImage || isVideo || nftContentType === NftContentType['3D']) {
            NftPreviewModal.open({ nft });
        }

        return undefined;
    }, [nftContentType, isVideo, isImage, nft]);

    return (
        <StyledWrapper
            isImage={isImage}
            isVideo={isVideo}
            isAudio={nftContentType === NftContentType.AUDIO}
            onClick={onClickMedia}
        >
            {imageSrc && !videoUrl && <StyledLazyLoadImage src={imageSrc} onContextMenu={preventDefault} />}
            {videoUrl && (
                <VideoWrapper>
                    <VideoInnerWrapper>
                        <video
                            muted
                            src={videoUrl}
                            autoPlay
                            playsInline
                            onContextMenu={preventDefault}
                            loop
                            controlsList="nodownload"
                        >
                            <source src={videoUrl} type={nft.contentType} />
                            <track kind="captions" srcLang="en" label="english_captions" />
                        </video>
                    </VideoInnerWrapper>
                </VideoWrapper>
            )}
        </StyledWrapper>
    );
};